module.exports = __webpack_public_path__ + "1a3758d5f80ce73dbcbc3c0aa44ea5e1.png";